/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakesdescription1Inputs */

const zh_learn_mistakesdescription1 = /** @type {(inputs: Learn_Mistakesdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回顾所有做错的题目`)
};

const en_learn_mistakesdescription1 = /** @type {(inputs: Learn_Mistakesdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review all incorrect answers`)
};

const es_learn_mistakesdescription1 = /** @type {(inputs: Learn_Mistakesdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa todas las respuestas incorrectas`)
};

/**
* | output |
* | --- |
* | "Review all incorrect answers" |
*
* @param {Learn_Mistakesdescription1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakesdescription1 = /** @type {((inputs?: Learn_Mistakesdescription1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakesdescription1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakesdescription1(inputs)
	if (locale === "en") return en_learn_mistakesdescription1(inputs)
	return es_learn_mistakesdescription1(inputs)
});
export { learn_mistakesdescription1 as "learn_mistakesDescription" }